import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import currencyActions from '../actions/currency';

function getSupportedCurrencies(store, action) {
    const preferredLocale = action.payload.preferredLocale;
    const siteName = store.getState().system.siteName;
    request.get(`/${config.url_prefix}/api/supportedCurrencies?locale=${preferredLocale}&site=${siteName}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(currencyActions.currencyServiceError('ipmob.internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    store.dispatch(currencyActions.getSupportedCurrenciesSuccess(res));
                } catch (exp) {
                    store.dispatch(currencyActions.currencyServiceError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSupportedCurrencies;
